import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';

const getCroppedImg = (imageSrc, pixelCrop) => {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        image,
        pixelCrop.x, pixelCrop.y,
        pixelCrop.width, pixelCrop.height,
        0, 0,
        pixelCrop.width, pixelCrop.height
      );
      canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.92);
    };
  });
};

function ImageCropper({ aspect, label, hint, onDone, preview, colors }) {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [open, setOpen] = useState(false);

  const onFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setOpen(true);
    };
    reader.readAsDataURL(file);
  };

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleConfirm = async () => {
    const blob = await getCroppedImg(imageSrc, croppedAreaPixels);
    const file = new File([blob], 'imagen.jpg', { type: 'image/jpeg' });
    onDone(file, URL.createObjectURL(blob));
    setOpen(false);
    setImageSrc(null);
  };

  return (
    <div>
      <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>
        {label} {hint && <span style={{ opacity: 0.6, fontSize: '0.75rem' }}>{hint}</span>}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
        <label style={{ backgroundColor: colors.accent, color: colors.accentText, padding: '0.5rem 1rem', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
          {preview ? 'Cambiar imagen' : 'Seleccionar imagen'}
          <input type="file" accept="image/*" onChange={onFileSelect} style={{ display: 'none' }} />
        </label>
        {preview && (
          <img src={preview} alt="preview" style={{ height: '60px', borderRadius: '6px', border: `1px solid ${colors.border}`, objectFit: 'cover' }} />
        )}
      </div>

      {open && (
        <div style={{
          position: 'fixed', inset: 0,
          backgroundColor: 'rgba(0,0,0,0.95)',
          zIndex: 9999,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          padding: '1rem',
        }}>
          <p style={{ color: '#fff', marginBottom: '1rem', fontSize: '0.95rem', fontWeight: 'bold' }}>
            Ajusta el encuadre de la imagen
          </p>
          <div style={{ position: 'relative', width: '100%', maxWidth: '480px', height: '380px', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#111' }}>
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>
          <div style={{ width: '100%', maxWidth: '480px', marginTop: '1rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
              <label style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem' }}>Zoom</label>
              <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem' }}>{zoom.toFixed(1)}x</span>
            </div>
            <input
              type="range" min={1} max={3} step={0.05} value={zoom}
              onChange={e => setZoom(Number(e.target.value))}
              style={{ width: '100%', accentColor: '#0099cc' }}
            />
          </div>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
            <button
              onClick={() => { setOpen(false); setImageSrc(null); }}
              style={{ backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', padding: '0.7rem 1.5rem', borderRadius: '8px', cursor: 'pointer', fontSize: '0.9rem' }}
            >
              Cancelar
            </button>
            <button
              onClick={handleConfirm}
              style={{ backgroundColor: '#00cc66', color: '#fff', border: 'none', padding: '0.7rem 2rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }}
            >
              Confirmar recorte
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageCropper;